export const getNextItemIndex = (currentItem, nItems) =>
  (currentItem + 1) % nItems;
export const getPreviousItemIndex = (currentItem, nItems) =>
  currentItem > 0 ? currentItem - 1 : nItems - 1;

export default {
  getNextItemIndex,
  getPreviousItemIndex
};
